import Vue from 'vue';
import PluginsTemplate from '../pluginsTemplate';
import moment from 'moment';

import DatetimeLocal from '@/components/base-ui/datetime/date-time.vue';
const baseDateSelectConstructor = Vue.extend(DatetimeLocal);

class SelectDatePlugin extends PluginsTemplate {
  constructor() {
    super();
    this.defaults = {
      show: true,
      startDate: moment().subtract(5, 'y').format('YYYY-MM-DD'),
      endDate: moment().add(5, 'y').format('YYYY-MM-DD'),
    };
  }
  show(options = {}) {
    this.clearTimer();
    // 特制化处理 多语言显示文案
    if (!options.cancelText) {
      options.cancelText = window.$t('common.key7', { cm: '取消' });
    }
    if (!options.confirmText) {
      options.confirmText = window.$t('common.key8', { cm: '确定' });
    }
    this.initPros(options);
    // 如果不存在实例 则初始化实例
    if (!this.instance) {
      let newInstance = new baseDateSelectConstructor({
        el: document.createElement('div'),
        propsData: this.props,
      });
      this.initInstance(newInstance);
    }
    // 初始化节点
    this.initDom();
  }
  initMethods() {
    this.instance.$off('on-change');
    this.instance.$on('on-change', (result) => {
      this.props.changeDate && this.props.changeDate(result);
    });
    this.instance.$off('on-hide');
    this.instance.$on('on-hide', (type) => {
      this.close();
      this.props.onHide && this.props.onHide(type);
    });
  }
  close() {
    if (!this.instance) {
      return !1;
    }
    this.instance.show = false;
    // 有动画效果需要延迟删元素
    this.clearTimer();
    this.timer = setTimeout(() => {
      this.removeInstance();
    }, 500);
  }
}

let instance = new SelectDatePlugin();

// 插件提供入口方法
export default {
  show(options) {
    instance.show(options);
    return instance;
  },
  close() {
    instance.close();
  },
  install() {
    instance.install();
  },
};
